// extracted by mini-css-extract-plugin
module.exports = {"buttonContainer":"FederatedLogins_buttonContainer__3yHn_","button":"FederatedLogins_button__UaZMH"};